module.exports = {

	methods: {
		closePickers: function(type) {

			if(type == 'undefined')
				type == 'all';

	    	// Change state
		    this.$store.commit('currentPicker', ""); 

		    // Tell pickers to reset
		    window.eventHub.$emit('clearSearch');
		    window.eventHub.$emit('closePickers', type);

		},

		resetPickerData(){
			this.$store.commit('currentPicker','')
			this.$store.commit('leftTitle', '')
		}
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/pickers.js